import { PDFViewer } from '@react-pdf/renderer';
import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { routeFileSelector } from '../../../../../utilz/i18n';
import CommonModal from '../../../../components/Modals/CommonModal';
import ContentSpinner from '../../../../components/Spinners/ContentSpinner';
import OverChargeClaimDetailsPrint from '../../../Print/Claims/Overcharge/OverChargeClaimDetailsPrint';
import { PrintFooter } from '../../common/PrintFooter';

const OverChargeDetailsPrintModal = ({ open, setOpen, claimDetails, isLoading, generatePDF, handlePrint }) => {
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  return (
    <CommonModal
      onClose={() => setOpen(false)}
      open={open}
      className="w-65"
      title={t('translation:claims.printOverchargeClaim')}
      descriptionClassName="m-0"
      customFooter={
        <PrintFooter handlePrint={handlePrint} details={claimDetails} generatePDF={generatePDF} setOpen={setOpen} />
      }
    >
      {isLoading ? (
        <ContentSpinner size="large" />
      ) : (
        <div className="pb-15 h-100">
          <PDFContent claimDetails={claimDetails} />
        </div>
      )}
    </CommonModal>
  );
};

const PDFContent = memo(({ claimDetails }) => (
  <PDFViewer showToolbar={false} width="100%" height="100%">
    <OverChargeClaimDetailsPrint claimDetails={claimDetails} />
  </PDFViewer>
));

export default OverChargeDetailsPrintModal;
